module.exports = __webpack_public_path__ + "img/test.24b3a62e.jpg";